
import Vue from "vue";

export default Vue.extend({
  name: "TheSidebar",

  async mounted() {
    this.$router.beforeEach(async (to, from, next) => {
      this.$globalData.scrollTop = document.querySelector(".sidebar")?.scrollTop || 0;
      return next();
    });

    document.querySelector(".sidebar")?.scrollTo(0, this.$globalData.scrollTop);
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },

    selectedMenuName(): string {
      return this.$router.currentRoute.name || "unknown";
    },

    isShow(): boolean {
      return this.$globalData.companyId === "df10f697-270a-46b0-9b89-2a78be9afd6d"
    },
  },

  methods: {
    menuClass(routeName: string): string {
      return routeName === this.selectedMenuName ? "active" : "";
    },
  },
});
